import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _ProductSupplier, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { FileService } from "../../../core/services/FileService";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { BasicButton } from "../../theme/Component/BasicButton";
import { Modal } from "../../theme/Component/Modal";
import { SelectProductEditor } from "../ManufacturingStandars/Components/SelectProductEditor";
import { SelectorUmeasurement } from "../../bpm/config/Componentes/SelectorUmeasurement";
import { AccountEditor } from "../../editor/AccountEditor";
import { InputMoney } from "../../theme/Input/InputMoney";
import { FileInput } from "../../theme/Component/FileInput";
import { SelectProductSupplierConstants } from "./Componentes/SelectProductSupplierConstants";

interface FormLike {
    Acc: number;
    Product: number;
}

export const ProductSupplier = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ProductSupplier);
    const [filter, setFilter] = useState<Partial<FormLike>>({});
    const fileService = new FileService();
    const modalEdit = useModal("", MODAL_LG);
    const modalDelete = useModal("Eliminar Referencia Cruzada", MODAL_SM);


    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        instance.getProductSupplierCatalog(filter.Acc, filter.Product).then(
            (resp: any) => {
                resp.forEach(element => {
                    const reference = element.DataBeanProperties;
                    reference.EntityMeasurement = `${reference.MeasurementUnitName ? `${reference.MeasurementUnitCode} - ${reference.MeasurementUnitName}` : "N/A"}`
                    reference.URL = reference.Media ? `<a href="${fileService.getUrlFile(reference.MediaContext, reference.Media)}" className="pointer" target='_blank'>Descargar Documento</a>` : "N/A";
                });

                setBean({});
                setLista(resp);
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const editaItem = () => {
        instance.updateProductSupplier(bean).then(
            (resp) => {
                getLista();
                modalEdit.close()
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        instance.deleteProductSupplier(bean.IDProductSupplier).then(
            (resp) => {
                getLista();
                modalDelete.close();
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProductSupplier', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Código de Producto', property: 'ProductCode', visible: true, mask: MASK_NUMBER },
        { title: 'Unidad de Medida', property: 'EntityMeasurement', visible: true },
        { title: 'Referencia del Proveedor', property: 'StockKeepingUnit', visible: true },
        { title: 'Proveedor', property: 'SupplierName', visible: true },
        { title: 'Precio Proveedor', property: 'PriceValue', visible: true, mask: MASK_MONEY },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Hoja de Vida/Especificaciones Producto', property: 'URL', visible: true },
    ]

    const create = () => {
        setBean({});
        modalEdit.setModal({ ...modalEdit.modal, "view": true, "name": "Agregar Referencias Cruzadas de Inventario" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEdit.setModal({ ...modalEdit.modal, "view": true, "name": "Editar Tipo de Labor" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalDelete.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDProduct", "IDMeasurementUnit", "IDAccount", "PriceValue", "State"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <BasicPage titulo="Referencias Cruzadas de Inventarios" >
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={filter.Acc} label="Proveedor" onChange={(e) => { setFilter({ ...filter, Acc: e.IDAccount }) }} />
                </div>

                <div className="col-md-6">
                    <SelectProductEditor label="Producto" value={filter.Product} onChange={(e) => { setFilter({ ...filter, Product: e.IDProduct }) }} />
                </div>

                <div className="col-md-6 mt-3">
                    <BasicButton eventClick={getLista} icon="ri-search-line" >
                        Buscar por Filtros
                    </BasicButton>
                </div>

                <div className="col-md-12">
                    <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem}
                    />
                </div>
            </div>


            <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteObjec}>
                <strong>Eliminar Informacion de {bean.ProductCode} - {bean.ProductName}</strong>
            </ModalConfirm>

            <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={validateData}>
                <div className="row">
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`}>Producto</label>
                        <SelectProductEditor label=" " renderValue={bean.ProductName} value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, IDProduct: e.IDProduct, ProductCode: e.ProductCode, StockKeepingUnit: e.StockKeepingUnit }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDMeasurementUnit') ? 'has-error' : ''}`}>Unidad de Medida</label>
                        <SelectorUmeasurement idSelector={bean.IDMeasurementUnit} onChange={(e) => { setBean({ ...bean, IDMeasurementUnit: e }) }} titulo=" " />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Proveedor</label>
                        <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('PriceValue') ? 'has-error' : ''}`}>Precio Proveedor</label>
                        <InputMoney _value={bean.PriceValue} onChange={(e) => { setBean({ ...bean, PriceValue: e }) }} _label=" " />
                    </div>
                    <div className="col-md-6">
                        <label className={`${missingFields.includes('State') ? 'has-error' : ''}`}>Estado</label>
                        <SelectProductSupplierConstants label=" " idSelector={bean.State} onChange={(e) => { setBean({ ...bean, State: e }) }} />
                    </div>
                    <div className="col-md-6">
                        <FileInput
                            onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext }) }}
                            Media={bean.Media}
                            MediaContext={bean.MediaContext}
                        />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>
                        <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }} />
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}